import { Component, computed } from '@angular/core';
import { CustomWidget } from '../widget';
import { CommonModule } from '@angular/common';
import { NumberPipe } from '@pipes/number.pipe';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';

@Component({
  selector: 'abb-number-and-list-widget',
  standalone: true,
  imports: [CommonModule, NumberPipe, TPipe],
  template: `
    <div class="flex h-full gap-x-4 items-start justify-evenly">
      <!-- Colonna del valore -->
      <div class="flex flex-col items-center gap-y-2 h-full">
        <div
          class="text-sm font-semibold uppercase tracking-wide text-gray-500"
        >
          {{ 'Number of alarms to be acknowledged' | t }}
        </div>
        <div
          class="flex h-full items-center justify-center text-5xl text-red-500 font-bold"
        >
          {{ value() | number : { maximumFractionDigits: 0 } }}
        </div>
      </div>

      <!-- Colonna della lista -->
      <div class="flex flex-col items-start gap-y-2 h-full">
        <div
          class="text-sm font-semibold uppercase tracking-wide text-gray-500"
        >
          {{ 'Properties' | t }}
        </div>
        <ul
          class="flex h-full flex-col items-center justify-center list-disc list-inside text-sm"
        >
          @for (el of list(); track $index) {
          <li>{{ el }}</li>
          }
        </ul>
      </div>
    </div>
  `,

  styles: ``,
  host: {
    class: 'block h-full',
  },
  providers: [
    {
      provide: TRANSLATION_PREFIX,
      useValue: 'dashboards.number_and_list_widget',
    },
  ],
})
export class NumberAndListWidgetComponent extends CustomWidget {
  value = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'NumberAndListData') {
      return data.value;
    }
    return 0;
  });

  list = computed(() => {
    const data = this.data();
    if (data && data.__typename === 'NumberAndListData') {
      return data.list;
    }
    return [];
  });
}
